// extracted by mini-css-extract-plugin
export default {"blog":"Blog_blog__VybVk","box":"Blog_box__oROUS","text":"Blog_text__e+STs","boxContainer":"Blog_boxContainer__00tFH"};